import styled from 'styled-components';
import theme from 'theme/theme';
import media from 'utils/MediaQueries';
import {
	PAGE_MAX,
	PAGE_PAD,
	PAGE_PAD_MOBILE,
} from 'components/Section/styled';

const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
`;

const Intro = styled.div`
	width: 100%;
	max-width: ${PAGE_MAX};
	padding: 0 ${PAGE_PAD};
	margin-top: 170px;
	margin-bottom: 20px;

	${media.tablet`
		margin-top: 110px;
		padding: 0 ${PAGE_PAD_MOBILE};
	`};
`;

const IntroEyebrow = styled.span`
	display: block;
	font-family: ${theme.monoFont};
	color: ${theme.primary1};
	font-size: 12px;
	font-weight: 500;
	letter-spacing: 2px;
	text-transform: uppercase;
	margin-bottom: 16px;
`;

const IntroTitle = styled.h1`
	font-family: ${theme.headerFont};
	color: ${theme.primary1};
	font-size: 44px;
	line-height: 1.18;
	max-width: 720px;
	margin: 0 0 22px 0;

	${media.phone`
		font-size: 30px;
	`};
`;

const IntroLead = styled.p`
	max-width: 620px;
	margin: 0;
	font-size: 18px;
	line-height: 1.65;
	color: ${theme.chalk};
	opacity: 0.78;
`;

/**
 * The quote block sits where a plan table normally would. It has to carry the
 * same visual weight the three cards used to, or the page reads as though the
 * pricing section simply failed to load.
 */
const QuoteBlock = styled.div`
	margin-top: 44px;
	padding-top: 38px;
	border-top: 1px solid ${theme.rule};
	scroll-margin-top: 110px;
`;

const QuoteTitle = styled.h2`
	font-family: ${theme.headerFont};
	color: ${theme.chalk};
	font-size: 28px;
	margin: 0 0 14px 0;

	${media.phone`
		font-size: 23px;
	`};
`;

const QuoteText = styled.p`
	max-width: 620px;
	margin: 0 0 28px 0;
	font-size: 16px;
	line-height: 1.7;
	color: ${theme.chalk};
	opacity: 0.72;
`;

const QuoteMeta = styled.p`
	margin: 22px 0 0 0;
	font-family: ${theme.monoFont};
	font-size: 12.5px;
	line-height: 1.8;
	color: ${theme.chalk};
	opacity: 0.45;
	max-width: 560px;
`;

const Closing = styled.div`
	width: 100%;
	max-width: ${PAGE_MAX};
	padding: 0 ${PAGE_PAD} 104px ${PAGE_PAD};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	${media.tablet`
		padding: 0 ${PAGE_PAD_MOBILE} 64px ${PAGE_PAD_MOBILE};
	`};
`;

const ClosingTitle = styled.h2`
	font-family: ${theme.headerFont};
	color: ${theme.chalk};
	font-size: 30px;
	margin: 0 0 14px 0;

	${media.phone`
		font-size: 24px;
	`};
`;

const ClosingText = styled.p`
	max-width: 560px;
	margin: 0 0 26px 0;
	font-size: 16px;
	line-height: 1.7;
	color: ${theme.chalk};
	opacity: 0.72;
`;

export {
	Wrapper,
	Intro,
	IntroEyebrow,
	IntroTitle,
	IntroLead,
	QuoteBlock,
	QuoteTitle,
	QuoteText,
	QuoteMeta,
	Closing,
	ClosingTitle,
	ClosingText,
};
